import { Image, AspectRatio, CSSObject } from '@chakra-ui/react'

import ImageSrc from '@/svg/services/decor-3.svg'

interface Props {
  sx?: CSSObject
}

function Decor3({ sx }: Props): React.ReactElement {
  return (
    <AspectRatio
      ratio={162 / 269}
      sx={{
        zIndex: -1,
        top: 0,
        left: 0,
        transform: 'translate3d(-10%, -50%, 0)',
        maxW: '162px',
        w: '20%',
        position: 'absolute',
        overflow: 'visible',
        ...sx,
      }}
    >
      <Image
        src={ImageSrc}
        alt="Decoration 3"
        sx={{ objectFit: 'contain !important' }}
      />
    </AspectRatio>
  )
}
export default Decor3
